import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ServerListActions } from 'actions';
import SelectMultiple from './SelectMultiple';

function mapStateToProps({ serverList }, { list }) {
    const listData = serverList[list] || {};
    return {
        loading: listData.loading || false,
        options: listData.data || [],
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getList: bindActionCreators(ServerListActions, dispatch).getList,
    };
}

class MultiSelectList extends PureComponent {
    state = {};

    componentDidMount() {
        this.getSelectList();
    }

    componentDidUpdate(prevProps) {
        const { list } = this.props;
        if (list !== prevProps.list) {
            this.getSelectList();
        }
    }

    getSelectList = () => {
        const { getList, list } = this.props;
        if (list && list.length > 0) {
            getList(list);
        }
    };

    filter = (option) => {
        const { parentValue, value = [] } = this.props;

        if (!Array.isArray(value)) return false;

        let show = true;

        if (parentValue) {
            show =
                option.idparent === parentValue ||
                option.idparent === '-1' ||
                option.idparent === '0';
        }

        show = show && !value.find((v) => v === option.value);

        return show;
    };

    render() {
        const { options = [], hidden, parentField, list, ...props } = this.props;

        if (hidden) {
            return null;
        }

        let finalOptions = options;
        if (!!parentField && options) {
            finalOptions = options.filter(this.filter);
        }

        return (
            <div className="fm-field-multi-server-list">
                <SelectMultiple {...props} options={finalOptions} />
            </div>
        );
    }
}

MultiSelectList.propTypes = {
    getList: PropTypes.func.isRequired,
    hint: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    onRemove: PropTypes.func,
    onChange: PropTypes.func,
    parentValue: PropTypes.string,
    value: PropTypes.arrayOf(PropTypes.any),
    className: PropTypes.string,
    error: PropTypes.node,
    mandatory: PropTypes.bool,
    readOnly: PropTypes.bool,
    hidden: PropTypes.bool,
    list: PropTypes.string,
    description: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.object),
    parentField: PropTypes.string,
};

export default connect(mapStateToProps, mapDispatchToProps)(MultiSelectList);
